import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DryContactConsumptionStatusValues } from '@vi-iot/client/apis/operational-data/operational-data.model';

@Pipe({
  name: 'dryContactConsumptionStatus',
  standalone: true,
})
export class DryContactConsumptionStatusPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): string {
    switch (value) {
      case DryContactConsumptionStatusValues.standby:
        return this.translateService.instant('+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.STANDBY');
      case DryContactConsumptionStatusValues.consuming:
        return this.translateService.instant('+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.CONSUMING');
      case DryContactConsumptionStatusValues.dataUnavailable:
        return this.translateService.instant(
          '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.DATA_UNAVAILABLE'
        );
      default:
        return '';
    }
  }
}
